import type { Ocupacao } from "./formato";
import { horas as emHoras, pct } from "./formato";

const DIAS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
// Uma cor só, do claro ao escuro: cinco degraus de opacidade sólida do azul da marca.
const DEGRAUS = ["bg-brand-600/10", "bg-brand-600/25", "bg-brand-600/45", "bg-brand-600/65", "bg-brand-600/85"];
const degrau = (taxa: number) => (taxa <= 0 ? "bg-zinc-100 dark:bg-muted" : DEGRAUS[Math.min(4, Math.floor(taxa * 5))]!);

/** Dia da semana × hora: quanto das cadeiras estava marcado naquela hora, no mês. */
export function MapaDeCalor({ mapa }: { mapa: Ocupacao["mapaDeCalor"] }) {
  if (!mapa.linhas.length || !mapa.horas.length) return null;
  return (
    <section className="rounded-xl border border-zinc-200 bg-white p-4 shadow-sm dark:border-border dark:bg-card">
      <h3 className="text-sm font-semibold text-zinc-900 dark:text-foreground">Horários mais cheios</h3>
      <p className="text-[11px] text-zinc-500 dark:text-muted-foreground">Parte das cadeiras com consulta em cada hora, somando o mês. Almoço e horas fora do expediente ficam tracejados.</p>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full min-w-[560px] border-separate" style={{ borderSpacing: 2 }}>
          <thead>
            <tr>
              <th className="w-10" />
              {mapa.horas.map((h) => (
                <th key={h} className="text-center text-[10px] font-medium tabular-nums text-zinc-500 dark:text-muted-foreground">
                  {String(h).padStart(2, "0")}h
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {mapa.linhas.map((l) => (
              <tr key={l.diaDaSemana}>
                <th className="pr-1 text-left text-[11px] font-medium text-zinc-600 dark:text-muted-foreground">{DIAS[l.diaDaSemana]}</th>
                {l.celulas.map((c, i) => (
                  <td
                    key={mapa.horas[i]}
                    title={c.taxa === null ? "Fora do expediente" : `${DIAS[l.diaDaSemana]} ${mapa.horas[i]}h: ${pct(c.taxa)} (${emHoras(c.min)} marcadas)`}
                    className={`h-7 rounded ${c.taxa === null ? "border border-dashed border-zinc-200 dark:border-border" : degrau(c.taxa)}`}
                  />
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-2 flex items-center justify-end gap-1.5 text-[10px] text-zinc-500 dark:text-muted-foreground">
        Vazio
        <span className="h-3 w-4 rounded-sm bg-zinc-100 dark:bg-muted" />
        {DEGRAUS.map((d) => (
          <span key={d} className={`h-3 w-4 rounded-sm ${d}`} />
        ))}
        Cheio
      </div>
    </section>
  );
}
